import type { ButtonProps } from '@wolfejs/ui/Button/Button';
import { Button } from '@wolfejs/ui/Button/Button';
import { cn } from '@wolfejs/ui/utils/classnames';

export type CartLineItemActionButtonProps = ButtonProps;

export const CartLineItemActionButton = ({ className, children, ...otherProps }: CartLineItemActionButtonProps) => {
  return (
    <Button className={cn('', className)} {...otherProps}>
      {children}
    </Button>
  );
};

